import { FC } from 'react';

import { AppFormattedMessage } from '../../../components/app-formatted-message/app-formatted-message';
import Button from '../../../components/button/index';
import { ModalWrapper } from '../../../components/modal-wrapper/index';
import { PageRoute } from '../../../types/page.types';
import { LibraryModalType } from '../enum/library-modal-type.enum';
import { LibraryModalStore } from '../store/library-modal.store';

export const LibraryDownloadModal: FC = () => {
  const isOpen = LibraryModalStore(({ isOpen }) => isOpen);
  const type = LibraryModalStore(({ type }) => type);
  const payload = LibraryModalStore(({ payload }) => payload);
  const handleAccept = LibraryModalStore(({ handleAccept }) => handleAccept);
  const handleDismiss = LibraryModalStore(({ handleDismiss }) => handleDismiss);

  const handleDownload = async () => {
    const path = payload?.downloadUrl?.trim();
    if (path) {
      const normalized = path.startsWith('/') ? path : `/${path}`;
      const fileUrl = new URL(normalized, window.location.origin).href;
      const response = await fetch(fileUrl);
      if (response.ok) {
        const blob = await response.blob();
        const objectUrl = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = objectUrl;
        link.download = normalized.split('/').pop() ?? 'download';
        link.rel = 'noopener noreferrer';
        document.body.appendChild(link);
        link.click();
        link.remove();
        URL.revokeObjectURL(objectUrl);
      }
    }
    handleAccept();
  };

  if (!payload || type !== LibraryModalType.DOWNLOAD) return null;

  return (
    <ModalWrapper
      className="centered flex h-screen w-screen p-2"
      control={{ modal: true, open: isOpen }}
      onBgClick={handleDismiss}
      side="CENTER"
    >
      <div className="flex w-full max-w-[453px] flex-col gap-6 rounded-lg bg-white px-6 py-4">
        <span className="max-lg:text-3xl text-[20px] font-semibold leading-8 text-gray-700">
          {payload.title}
        </span>

        <div className="flex flex-col gap-2 rounded-[4px] bg-gray-50 p-3 text-xs text-gray-700">
          <p className="font-[550] text-fireside-600">
            <AppFormattedMessage id="LIBRARY_DISCLAIMER_TITLE" />
          </p>
          <p>
            <AppFormattedMessage id="LIBRARY_DISCLAIMER_TEXT" />
          </p>
        </div>

        <div className="rounded-lg bg-brand-25 p-3 text-xs text-gray-700">
          <AppFormattedMessage id="LIBRARY_DOCUSIGN_NOTE" />{' '}
          <button
            className="inline text-gray-700 underline"
            onClick={() => {
              window.open(PageRoute.GUIDES, '_blank', 'noopener,noreferrer');
            }}
            type="button"
          >
            <AppFormattedMessage id="LIBRARY_MAPPING_GUIDE" />
          </button>{' '}
          <AppFormattedMessage id="LIBRARY_DOCUSIGN_NOTE_TAIL" />
        </div>

        <div className="mt-2 flex justify-end gap-3">
          <Button
            className="w-fit border border-gray-300 bg-white px-6 py-[10px] text-sm text-gray-700"
            onClick={handleDismiss}
            styleType="NONE"
          >
            <AppFormattedMessage id="CANCEL" />
          </Button>
          <Button className="w-fit px-6 py-[10px]" onClick={handleDownload}>
            <AppFormattedMessage id="DOWNLOAD" />
          </Button>
        </div>
      </div>
    </ModalWrapper>
  );
};
